import {register} from '../vendor/theme-scripts/theme-sections';
import popupVideoSection from '../features/popup-video';
import {customScrollbar} from '../features/custom-scrollbar';

register('section-columns', [popupVideoSection, customScrollbar]);
